import { Link } from 'react-router-dom';
import { categoryList } from '@/mocks/categories';

export default function CategoryShortcuts() {
  return (
    <section aria-label="分类快捷入口" className="w-full px-4 md:px-8 -mt-10 relative z-30">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
        {categoryList.map((item, index) => (
          <Link
            key={item.key}
            to={item.path}
            className="group bg-background-50 rounded-lg border border-background-200 p-4 md:p-5 flex items-center gap-4 hover:border-accent-400 transition-colors animate-fade-up"
            style={{ animationDelay: `${index * 80}ms` }}
          >
            <span className="w-12 h-12 md:w-14 md:h-14 shrink-0 rounded-md bg-primary-500 text-background-50 flex items-center justify-center group-hover:bg-accent-500 group-hover:text-primary-950 transition-colors">
              <i className={`${item.icon} text-xl md:text-2xl`} />
            </span>
            <span className="flex-1 min-w-0">
              <span className="flex items-center justify-between gap-2">
                <span className="text-base md:text-lg font-bold text-foreground-950 whitespace-nowrap">{item.label}</span>
                <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-accent-600 transition-colors" />
              </span>
              <span className="mt-1 block text-[11px] md:text-xs text-foreground-500 truncate">{item.accentNote}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}